import { DEFAULT_SEARCH_PARAMS } from 'constants/tables';

import { PathName } from 'enums/pathName';
import { Role } from 'enums/role';
import { RouteProps } from 'router/router.types';

export const routes: RouteProps[] = [
  {
    page: 'CrossSell',
    path: PathName.CrossSell,
    permissions: [Role.PH, Role.AD, Role.CS, Role.NP, Role.MA, Role.MD]
  },
  {
    label: 'Tasks',
    page: 'Tasks',
    path: PathName.Tasks,
    permissions: [Role.PH, Role.AD, Role.CS, Role.NP, Role.MA],
    searchParams: '?limit=50&pageNo=0&sort[dueDate]=ASC',
    sidebar: true
  },
  {
    label: 'MSR Tasks',
    page: 'MSRTasksQueue',
    path: PathName.MSRTasks,
    permissions: [Role.AD, Role.CS, Role.MA],
    sidebar: true
  },
  {
    page: 'MSRTaskDetail',
    path: PathName.MSRTaskDetail,
    permissions: [Role.AD, Role.CS, Role.MA]
  },
  {
    label: 'MSR Tasks Configuration',
    page: 'MSRTasksConfig',
    path: PathName.MSRTasksConfig,
    permissions: [Role.AD]
  },
  {
    label: 'Activity feed',
    page: 'ActivityFeed',
    path: PathName.ActivityFeed,
    permissions: [Role.PH, Role.AD, Role.CS, Role.NP, Role.MA],
    searchParams: '?active-tab=Inbox',
    sidebar: true
  },
  {
    label: 'Calendar',
    page: 'Appointments',
    path: PathName.Calendar,
    permissions: [Role.PH, Role.AD, Role.CS, Role.NP, Role.MA],
    sidebar: true
  },
  {
    label: 'Scheduling',
    page: 'Scheduling',
    path: PathName.Scheduling,
    permissions: [Role.PH, Role.AD, Role.NP, Role.MA],
    sidebar: true
  },
  {
    page: 'Scheduling',
    path: PathName.SchedulingCoverage,
    permissions: [Role.PH, Role.AD, Role.NP, Role.MA]
  },
  {
    page: 'Scheduling',
    path: PathName.SchedulingRoster,
    permissions: [Role.PH, Role.AD, Role.NP, Role.MA]
  },
  {
    page: 'Scheduling',
    path: PathName.SchedulingTimeline,
    permissions: [Role.PH, Role.AD, Role.NP, Role.MA]
  },
  {
    page: 'Scheduling',
    path: PathName.SchedulingCapacity,
    permissions: [Role.PH, Role.AD, Role.NP, Role.MA]
  },
  {
    page: 'Scheduling',
    path: PathName.SchedulingTemplates,
    permissions: [Role.PH, Role.AD, Role.NP, Role.MA]
  },
  {
    page: 'Scheduling',
    path: PathName.SchedulingInsurance,
    permissions: [Role.PH, Role.AD, Role.NP, Role.MA]
  },
  {
    label: 'Insurance',
    page: 'Insurance',
    path: PathName.Insurance,
    permissions: [Role.AD],
    sidebar: true
  },
  {
    label: 'Insurance',
    page: 'Insurance',
    path: `${PathName.Insurance}/bridge`,
    permissions: [Role.AD]
  },
  {
    label: 'Insurance',
    page: 'Insurance',
    path: `${PathName.Insurance}/eligibility`,
    permissions: [Role.AD]
  },
  {
    label: 'Insurance',
    page: 'Insurance',
    path: `${PathName.Insurance}/availability-matrix`,
    permissions: [Role.AD]
  },
  {
    label: 'Reports',
    page: 'AdminReports',
    path: PathName.AdminReports,
    permissions: [Role.AD],
    sidebar: true
  },
  {
    label: 'Reports',
    page: 'MedicalAssistantReports',
    path: PathName.MedicalAssistantReports,
    permissions: [Role.MA],
    sidebar: true
  },
  {
    label: 'Reports',
    page: 'PhysicianReports',
    path: PathName.PhysicianReports,
    permissions: [Role.PH],
    sidebar: true
  },
  {
    label: 'Patients',
    page: 'Prospects',
    path: PathName.Prospect,
    permissions: [Role.AD, Role.CS, Role.NP, Role.MA],
    searchParams: DEFAULT_SEARCH_PARAMS
  },
  {
    label: 'Availability',
    page: 'Availability',
    path: `${PathName.Availability}/:id`,
    permissions: [Role.PH, Role.MA, Role.AD]
  },
  {
    label: 'Patients',
    page: 'Patients',
    path: PathName.Patients,
    permissions: [Role.PH, Role.AD, Role.CS, Role.NP, Role.MA],
    searchParams: DEFAULT_SEARCH_PARAMS,
    sidebar: true
  },
  {
    label: 'Patient',
    page: 'Patient',
    path: `${PathName.Patient}/:patientId`,
    permissions: [Role.PH, Role.AD, Role.CS, Role.NP, Role.MA]
  },
  {
    label: 'CreateArticle',
    page: 'CreateArticle',
    path: PathName.CreateArticle,
    permissions: [Role.PH, Role.AD, Role.CS, Role.NP, Role.MA]
  },
  {
    label: 'Article',
    page: 'CreateArticle',
    path: `${PathName.UpdateArticle}/:articleId`,
    permissions: [Role.PH, Role.AD, Role.CS, Role.NP, Role.MA]
  },
  {
    label: 'Article',
    page: 'SingleArticle',
    path: `${PathName.Articles}/:articleId`,
    permissions: [Role.PH, Role.AD, Role.CS, Role.NP, Role.MA]
  },
  {
    label: 'Templates',
    page: 'Templates',
    path: PathName.Templates,
    permissions: [Role.PH, Role.AD, Role.CS, Role.NP, Role.MA, Role.MD],
    sidebar: true
  },
  {
    label: 'Articles',
    page: 'Articles',
    path: PathName.Articles,
    permissions: [Role.PH, Role.AD, Role.CS, Role.NP, Role.MA],
    searchParams: DEFAULT_SEARCH_PARAMS,
    sidebar: true
  },
  {
    label: 'Admin',
    page: 'Admin',
    path: PathName.Admin,
    permissions: [Role.AD],
    sidebar: true
  },
  {
    label: 'System Settings',
    page: 'Settings',
    path: PathName.SystemSettings,
    permissions: [Role.AD]
  },
  {
    label: 'Staff Announcements',
    page: 'StaffAnnouncements',
    path: PathName.StaffAnnouncements,
    permissions: [Role.AD]
  },
  {
    label: 'Aging Configurations (inactive)',
    page: 'AgingConfig',
    path: PathName.AgingConfiguration,
    permissions: [Role.AD],
    searchParams: DEFAULT_SEARCH_PARAMS
  },
  {
    label: 'Appointment Types',
    page: 'AppointmentTypes',
    path: PathName.AppointmentTypes,
    permissions: [Role.AD],
    searchParams: DEFAULT_SEARCH_PARAMS
  },
  {
    label: 'Forms & Surveys',
    page: 'FormsAndSurveys',
    path: PathName.FormsAndSurveys,
    permissions: [Role.AD]
  },
  {
    label: 'MIF form editor',
    page: 'MifEditPage',
    path: `${PathName.FormsAndSurveys}/mif/:idOrCode`,
    permissions: [Role.AD]
  },
  {
    label: 'FrontDesk Request Types',
    page: 'FrontDeskRequestTypes',
    path: PathName.FrontDeskRequestTypes,
    permissions: [Role.AD],
    searchParams: DEFAULT_SEARCH_PARAMS
  },
  {
    label: 'Patient Message Templates',
    page: 'PatientMessageTemplates',
    path: PathName.PatientMessageTemplates,
    permissions: [Role.AD],
    searchParams: DEFAULT_SEARCH_PARAMS
  },
  {
    label: 'Request Message Templates',
    page: 'RequestMessageTemplates',
    path: PathName.RequestMessageTemplates,
    permissions: [Role.AD],
    searchParams: DEFAULT_SEARCH_PARAMS
  },
  {
    label: 'Internal note templates',
    page: 'InternalNoteTemplates',
    path: PathName.InternalNoteTemplates,
    permissions: [Role.AD],
    searchParams: DEFAULT_SEARCH_PARAMS
  },
  {
    label: 'Medication templates',
    page: 'MedicationTemplates',
    path: PathName.MedicationTemplates,
    permissions: [Role.AD],
    searchParams: DEFAULT_SEARCH_PARAMS
  },
  {
    label: 'PDMP configs',
    page: 'PdmpConfigs',
    path: PathName.PdmpConfigs,
    permissions: [Role.AD]
  },
  {
    label: 'Email templates',
    page: 'EmailTemplates',
    path: PathName.EmailTemplates,
    permissions: [Role.AD],
    searchParams: DEFAULT_SEARCH_PARAMS
  },
  {
    label: 'Email template (new)',
    page: 'EmailTemplate',
    path: `${PathName.EmailTemplates}/new`,
    permissions: [Role.AD]
  },
  {
    label: 'Email template (edit)',
    page: 'EmailTemplate',
    path: `${PathName.EmailTemplates}/:id`,
    permissions: [Role.AD]
  },
  {
    label: 'Staffs',
    page: 'Staffs',
    path: PathName.Staffs,
    permissions: [Role.AD],
    searchParams: DEFAULT_SEARCH_PARAMS
  },
  {
    label: 'Teams',
    page: 'Teams',
    path: PathName.Teams,
    permissions: [Role.AD],
    searchParams: DEFAULT_SEARCH_PARAMS
  },
  {
    label: 'Reviews',
    page: 'Reviews',
    path: PathName.Reviews,
    permissions: [Role.AD],
    searchParams: DEFAULT_SEARCH_PARAMS
  },
  {
    label: 'Reviews',
    page: 'StaffFeedback',
    path: PathName.StaffFeedback,
    permissions: [Role.AD],
    searchParams: DEFAULT_SEARCH_PARAMS
  },
  {
    label: 'Reviews',
    page: 'CustomerFeedback',
    path: PathName.CustomerFeedback,
    permissions: [Role.AD],
    searchParams: DEFAULT_SEARCH_PARAMS
  },
  {
    label: 'Manage Roles',
    page: 'ManageRoles',
    path: PathName.ManageRoles,
    permissions: [Role.AD],
    searchParams: DEFAULT_SEARCH_PARAMS
  },
  {
    label: 'Manage Role',
    page: 'ManageRole',
    path: `${PathName.ManageRole}/:id`,
    permissions: [Role.AD]
  },
  {
    label: 'Internal Automations',
    page: 'InternalAutomations',
    path: PathName.InternalAutomations,
    permissions: [Role.AD],
    searchParams: DEFAULT_SEARCH_PARAMS
  },
  {
    label: 'Patient Automations',
    page: 'PatientAutomations',
    path: PathName.PatientAutomations,
    permissions: [Role.AD],
    searchParams: DEFAULT_SEARCH_PARAMS
  },
  {
    label: 'Staff costs configuration',
    page: 'StaffCosts',
    path: PathName.StaffCosts,
    permissions: [Role.AD],
    searchParams: DEFAULT_SEARCH_PARAMS
  },
  {
    label: 'Billing configuration',
    page: 'BillingConfiguration',
    path: PathName.BillingConfiguration,
    permissions: [Role.AD],
    searchParams: DEFAULT_SEARCH_PARAMS
  },
  {
    label: 'Refund Reasons',
    page: 'RefundReasons',
    path: PathName.RefundReasons,
    permissions: [Role.AD]
  },
  {
    label: 'Orders',
    page: 'Orders',
    path: PathName.Orders,
    permissions: [Role.AD, Role.CS, Role.MA, Role.PH, Role.NP],
    sidebar: true,
    sidebarExcludedRoles: [Role.PH, Role.NP]
  },
  {
    label: 'AI Tools',
    page: 'AiTools',
    path: PathName.AiTools,
    permissions: [Role.PH, Role.AD, Role.CS, Role.NP, Role.MA, Role.MD],
    sidebar: true
  },
  {
    label: 'Workflows',
    page: 'Workflows',
    path: PathName.Workflows,
    permissions: [Role.AD],
    sidebar: true
  },
  {
    label: 'Workflows',
    page: 'WorkflowDetails',
    path: PathName.WorkflowDetails,
    permissions: [Role.AD]
  },
  {
    label: 'Order',
    page: 'OrderDetails',
    path: `${PathName.Orders}/:orderId`,
    permissions: [Role.AD, Role.CS, Role.MA, Role.PH, Role.NP]
  },
  {
    label: 'Manage Products',
    page: 'StoreProducts',
    path: PathName.ManageProducts,
    permissions: [Role.AD]
  },
  {
    label: 'Shop Segments',
    page: 'ShopSegments',
    path: PathName.ShopSegments,
    permissions: [Role.AD]
  },
  {
    label: 'Shop Pages',
    page: 'ShopPages',
    path: PathName.ShopPages,
    permissions: [Role.AD]
  },
  {
    label: 'QA',
    page: 'QA',
    path: PathName.QA,
    permissions: [Role.AD],
    sidebar: true
  },
  {
    label: 'Clinical tools',
    page: 'ClinicalTools',
    path: PathName.ClinicalTools,
    permissions: [Role.AD, Role.NP],
    sidebar: true
  },
  {
    label: 'QA',
    page: 'QA',
    path: `${PathName.QA}/appointments`,
    permissions: [Role.AD]
  },
  {
    label: 'QA',
    page: 'QA',
    path: `${PathName.QA}/renewals`,
    permissions: [Role.AD]
  }
];
